import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {SimMaterialDialogService} from "@services";
import {Translations} from "@translations";

export interface DialogDataConfirmStopRecordingDialog extends MatDialogDataBaseInput {}

export interface DialogDataConfirmStopRecordingDialogOutput extends MatDialogDataBaseOutput {
	followUpAction: "stop" | "cancel" | "abort";
}

@Component({
	selector: "sim-confirm-stop-recording-dialog",
	templateUrl: "./confirm-stop-recording-dialog.component.html",
	styleUrls: ["./confirm-stop-recording-dialog.component.scss"],
	standalone: false,
})
export class ConfirmStopRecordingDialogComponent extends BasicMaterialDialog<
	ConfirmStopRecordingDialogComponent,
	DialogDataConfirmStopRecordingDialog,
	DialogDataConfirmStopRecordingDialogOutput
> {
	T = Translations;

	public countDown: number = 10;
	public countDownIntervall;

	constructor(
		_injector: Injector,
		private _simMaterialDialog: SimMaterialDialogService,
	) {
		super(_injector);

		this.countDownIntervall = setInterval(
			() => {
				this.countDown--;

				if (this.countDown <= 0) {
					this.close({action: "ok", followUpAction: "stop"});
					clearInterval(this.countDownIntervall);
				}
			},
			1000,
			this.countDown,
		);
	}

	public deleteAndAbortClicked() {
		this._simMaterialDialog
			.openDeleteDialog({
				deleteTitle: "Do you really want to abort this Training",
				deleteText: "By aborting this training all recorded files will be deleted.",
				deleteButtonText: "Delete and Abort",
				cancelText: "Cancel",
			})
			.then((value) => {
				if (value.action === "ok") {
					this.close({action: "ok", followUpAction: "abort"});
				}
			});
	}
}
